import PropTypes from 'prop-types';
import React from 'react';
import { Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import DirectionProvider, { DIRECTIONS } from 'react-with-direction/dist/DirectionProvider';
import { ImgProvider, RENDER_IMAGE_WITH_PLACEHOLDER_INITIALLY } from '@wix/communities-image-lib';
import rtlDetect from 'rtl-detect';
import 'reset-css';

import NavigationProvider from '../../../app/components/navigation-provider';
import PermissionsProvider from '../../../app/components/permissions-provider';
import createWidgetNavigation from '../../../app/services/navigation-provider/blog-widget';
import DirectionProviderWrapper from '../../../app/components/direction-provider-wrapper';
import Widget from '../widget';

const WidgetRoot = ({ store, i18n }) => (
  <Provider store={store}>
    <NavigationProvider navigation={createWidgetNavigation(store)}>
      <PermissionsProvider store={store}>
        <I18nextProvider i18n={i18n}>
          <DirectionProviderWrapper>
            <DirectionProvider direction={rtlDetect.isRtlLang(i18n.language) ? DIRECTIONS.RTL : DIRECTIONS.LTR}>
              <ImgProvider renderMode={RENDER_IMAGE_WITH_PLACEHOLDER_INITIALLY}>
                <Widget />
              </ImgProvider>
            </DirectionProvider>
          </DirectionProviderWrapper>
        </I18nextProvider>
      </PermissionsProvider>
    </NavigationProvider>
  </Provider>
);

WidgetRoot.propTypes = {
  store: PropTypes.object.isRequired,
  i18n: PropTypes.object.isRequired,
};

export default WidgetRoot;
